/**
 * Reine Cursor-Logik für die Lern-Queue.
 *
 * Wird NACH applyReview + refreshDue aufgerufen, also gegen die bereits
 * aktualisierte dueIds-Liste — so wird im review-Modus keine Karte
 * übersprungen (der alte Code advancte vor refreshDue auf stale dueIds).
 */
export function nextCursor(
  prevCursor: number,
  dueIdsAfter: readonly string[],
  reviewedId: string,
): number {
  const idx = dueIdsAfter.indexOf(reviewedId);
  if (idx === -1) {
    // review-Modus: bewertete Karte ist nicht mehr fällig und aus der Liste
    // entfernt → die nachfolgende Karte ist an prevCursor nachgerückt.
    return Math.min(prevCursor, Math.max(0, dueIdsAfter.length - 1));
  }
  // study/all-Modus: Karte bleibt in der Liste → eins weiterrücken.
  return dueIdsAfter.length ? (idx + 1) % dueIdsAfter.length : 0;
}
